import { TextFieldWrapper } from "../style/ConditionSelector.styled";

export default function TextFieldView () {
    return (
        <TextFieldWrapper>
            <div>* 검색 기간 내에 판매된 상품의 카테고리가 조회됩니다.</div>
            <div>* 선택된 카테고리들의 판매 데이터를 비교할 수 있습니다.</div>
        </TextFieldWrapper>
    )
}